import React, { useCallback, useState } from 'react';
import {
  TweakPanelBookingInput,
  useGetPanelBookingDatesQuery,
  useUpdatePanelBookingMutation, useDeletePanelBookingMutation, useUpdatePanelBookingDateMutation
} from '../../generated/graphql';

import { WaitSpinner } from '../../components/wait-spinner';
import { Link } from 'react-router-dom';
import { isoDateToMMM, getWeekNum, getWeekForNum } from '../../utils';
import {parse, format, parseISO} from 'date-fns';
import crown from "@iconify/icons-fa-solid/crown";
import { Icon } from '@iconify/react';
import { useUserContext} from '../../contexts/user-context';
import {Button, ButtonGroup, Tooltip, Typography, Link as MuiLink, Accordion, AccordionSummary} from '@mui/material';
import {
  ArrowUpward,
  Cancel,
  ChevronLeft,
  ChevronRight, Compress,
  Delete, Expand, Save
} from "@mui/icons-material";
import {NonIdealState} from "../../components/NonIdealState";
import {useSnackbar} from "notistack";
import { AccordionDetails } from '@mui/material';
import Grid3x3Icon from '@mui/icons-material/Grid3x3';
import { ModalWindow } from '../../components/ModalWindow';



const PanelBookingsInspector = (props: { panelId: number, weekNum: number,inspectorId:number }) => {
  const { loading, error, data, refetch } = useGetPanelBookingDatesQuery(
    {
      variables: {
        panel_id: props.panelId.toString(),
        week_number: props.weekNum,
        inspector_id: props.inspectorId
      },
      fetchPolicy: "network-only"
    });
  const {enqueueSnackbar} = useSnackbar();
  const [updatePanelBooking] = useUpdatePanelBookingMutation();
  const [deletePanelBookingMutation] = useDeletePanelBookingMutation();
//      useMutation<Mutation>(deletePanelBooking);
  const [updatePanelBookingDate] = useUpdatePanelBookingDateMutation();
  const [requiresOverride,setRequiresOverride] = useState<TweakPanelBookingInput|null>(null);
//      useMutation<Mutation>(updatePanelBookingDateMutation);
  const user = useUserContext();
  const increasePriority = useCallback(async (evt) => {
    evt.preventDefault();
    const thisEl = evt.target.closest('[data-bd_id]');
    const params: TweakPanelBookingInput = {
      id: thisEl.dataset.bd_id,
      increasePriority: true
    };
    enqueueSnackbar('Updating booking');
    try {
      const { data } = await updatePanelBookingDate({ variables: params });
      enqueueSnackbar('Booking updated',{variant:'success'});
      refetch();
    } catch (e) {
      console.trace();
      console.warn(e);
      enqueueSnackbar(<span>Unable to update booking{(e.message?<><br/>{e.message.replace('GraphQL error:', ' ').trim()}</>:null)}</span>,{variant:'error'});
    }
  }, [refetch, updatePanelBookingDate]);
  const forceMoveWeek = useCallback(async () => {
    if(!requiresOverride) return;
    const params = {...requiresOverride};
    params.ignore_loss_of_pole = true;
    enqueueSnackbar('Updating booking');
    try {
      const {data} = await updatePanelBooking({variables: params});
      enqueueSnackbar('Booking updated',{variant:'success'});
      refetch();
      setRequiresOverride(null);
    } catch (e) {
      enqueueSnackbar(<span>Unable to update booking{(e.message?<><br/>{e.message.replace('GraphQL error:', ' ').trim()}</>:null)}</span>,{variant:'error'});
      setRequiresOverride(null);
    }
  }, [refetch, updatePanelBooking,requiresOverride]);


  const moveWeek = useCallback(async (evt) => {
    evt.preventDefault();
    const dataEl = evt.target.closest('[data-booking_id]');
    const thisEl = evt.target.closest('[data-move_week]');
    const params: TweakPanelBookingInput = {
      id: dataEl.dataset.booking_id,
      week_number: parseInt(dataEl.dataset.first_week) + parseInt(thisEl.dataset.move_week),
      num_weeks: parseInt(dataEl.dataset.num_weeks) + parseInt(thisEl.dataset.change_duration),
      increase_priority: parseInt(thisEl.dataset.increase_priority),
      trim:parseInt(thisEl.dataset.trim)
    };

    console.log('mw', params);
    enqueueSnackbar('Updating booking');
    //    toast.info('Updating booking', { toastId: 'bookingPanel' });
    try {
      const {data} = await updatePanelBooking({variables: params});
      console.log('not error?', data, error);
      enqueueSnackbar('Booking updated',{variant:'success'});
      refetch();
    } catch (e) {
      console.log('GQCHECK-PRE',JSON.stringify(e));
      // if this would action lose POLE position, save the params and show the popup
      const foundError = e.graphQLErrors?.find((error)=>{
        console.log('GQCHECK',error,error.category);
        return (error?.extensions?.category=='POLE');
      });
      if(foundError) {
        setRequiresOverride(params);
        return;
      }
      console.log('GQCHECKED',e.graphqlErrors);
      enqueueSnackbar(<span>Unable to update booking{(e.message?<><br/>{e.message.replace('GraphQL error:', ' ').trim()}</>:null)}</span>,{variant:'error'});
      setRequiresOverride(null);
    }
  }, [refetch, updatePanelBooking]);
  const deleteBooking = useCallback(async (evt) => {
    evt.preventDefault();
    const dataEl = evt.target.closest('[data-booking_id]');
    const params = {id: dataEl.dataset.booking_id};
    enqueueSnackbar('Deleting booking');
    try {
      await deletePanelBookingMutation({ variables: params });
      enqueueSnackbar('Booking deleted',{variant:'success'});
      refetch();
    } catch (e) {
      enqueueSnackbar(e.message?e.message:'Unable to delete booking',{variant:'error'});
    }
  }, [deletePanelBookingMutation, refetch]);
  if (loading) return <WaitSpinner variant="panel" />;
  if (error) return <NonIdealState title="An error has occurred" />;

  const rows = data.panelBookingDates.data;
  const date = getWeekForNum(props.weekNum);
  const content = rows.map(function (v) {
    console.log('v is',v);
    return (
      <>
        <div className={'panel-booking-detail booking-status__bg__' + v.panelBooking.status.toLowerCase()} key={v.id}>
          <Typography variant="body2"
              className="panel-booking-detail__header">
            {v.hasPole && <Icon icon={crown}/>}
            <MuiLink component={Link} to={'/campaigns/' + v.panelBooking.campaign?.job_reference}>{v.panelBooking.campaign?.job_reference}
                </MuiLink>
            - {v.panelBooking.campaign?.name} [{v.panelBooking.campaign?.ourContact?.name}]
          </Typography>
          {!!v.panelBooking.inboundChallenges && v.panelBooking.inboundChallenges.length > 0 && v.panelBooking.inboundChallenges[0].status=='ACTIVE' &&
              <div className="panel-booking-detail__row">
                <Typography variant="body2" sx={(theme)=>({color:theme.palette.warning.main})}>
                  Booking under challenge until {format(parseISO(v.panelBooking.inboundChallenges[0].expires),'E H:m')}
                </Typography>
              </div>
          }
          <div className="panel-booking-detail__row">
            <Typography variant="body2">{v.panelBooking.posterSize?.name}</Typography>
          </div>
          <div className="panel-booking-detail__row">
            <Typography variant="body2">{v.panelBooking.weeks} Weeks
              / {isoDateToMMM(v.panelBooking.first_week)} - {isoDateToMMM(v.panelBooking.lastDate)}</Typography>
          </div>
          <div className="panel-booking-detail__row">
            <Typography variant="body2">{v.panelBooking.status === 'Pencil' ? 'Pencil' : 'Booked'}
              {v.panelBooking.is_slot ? ' Commercial 60x40s' : ''}
            </Typography>
          </div>
          <div className="panel-booking-detail__row">
            <Typography variant="body2">[Campaign {v.panelBooking.campaign.status}]</Typography>
          </div>
          <div>
            <ButtonGroup className="panel-booking-detail__actions" fullWidth={true}
                         size="small"
                         data-first_week={getWeekNum(parse(v.panelBooking.first_week, 'yyyy-MM-dd', new Date()))}
                         data-booking_id={v.panelBooking.id}
                         data-num_weeks={v.panelBooking.weeks}
                         data-bd_id={v.id}
            >
              {user.hasPermission('panelbookings.reprioritize') && v.panelBooking.status == 'Pencil' && !v.hasPole &&
                  <Tooltip title="Increase the priority of this booking for this week"><Button
                      color="warning"
                      onClick={increasePriority}
                      ><ArrowUpward/></Button></Tooltip>}
              <Button
                  data-move_week="-1"
                  data-change_duration="0"
                  data-increase_priority="0"
                  onClick={moveWeek}
                  title="Move to previous week"
                  ><ChevronLeft/></Button>
              <Button
                  data-move_week="1"
                  data-change_duration="0"
                  data-increase_priority="0"
                  onClick={moveWeek} title="Move to next week"><ChevronRight/></Button>
              <Button onClick={moveWeek}
                      data-change_duration="1"
                      data-move_week="0"
                      data-increase_priority="0"
                      title="Extend duration by 1 week"><Expand/></Button>
              <Button
                  data-change_duration="-1"
                  data-move_week="0"
                  data-trim="0"
                  data-increase_priority="0"
                  onClick={moveWeek} title="Shorten duration by 1 week"><Compress/></Button>
              <Button
                  data-change_duration="0"
                  data-move_week="0"
                  data-increase_priority="0"
                  data-trim="1"
                  onClick={moveWeek} title="Trim booking to weeks with 1st option"><Icon icon="fluent-mdl2:trim" fontSize={20}/></Button>
              <Button onClick={deleteBooking} color="error" title="Delete this booking"><Delete/></Button>
            </ButtonGroup>
          </div>
        </div>
        </>
    )
  });
  return (
  <Accordion defaultExpanded={true}><AccordionSummary>Details</AccordionSummary>
    <AccordionDetails><Typography variant="body2" key={0}>{data?.panel?.site?.name}<br/>{format(date, 'dd MMM yyyy')}</Typography></AccordionDetails>
    {content}
    <ModalWindow isOpen={!!requiresOverride} onClose={()=>setRequiresOverride(null)} header={
            "Warning"
        } actions={
            <>
            <Button size="large" color="warning" onClick={()=>setRequiresOverride(null)} startIcon={<Cancel/>}>Cancel</Button>
            <Button size="large" color="primary" onClick={forceMoveWeek} startIcon={<Save/>}>Save, losing pole</Button>
            </>
        }>
          <Typography>This booking would lose 1st option for 1 or more weeks by this action.<br/>
Use <Typography color="primary" style={{display:'inline-block'}}><Icon icon="fluent-mdl2:trim"  /></Typography> to trim booking to weeks where 1st option has been won.</Typography>
        </ModalWindow>
    </Accordion>
  );
}

export default PanelBookingsInspector;